import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { ICustomNotification } from '../models/notification/customNotification.interface';
import { ITicketDialogModel } from '../models/ticket-validation/ticketDialogModel.interface';

@Injectable()
export class NotificationService {
    private notificationDialogSource = new Subject<ICustomNotification>();
    private closeNotificationSource = new Subject<any>();
    // private closeConfirmTicketDialogsource = new Subject<any>();
    private ticketDialogSource = new Subject<ITicketDialogModel>();

    closeNotificationDialog$ = this.closeNotificationSource.asObservable();
    notificationDialogData$ = this.notificationDialogSource.asObservable();
    // closeConfirmTicketDialog$ = this.closeConfirmTicketDialogsource.asObservable();
    ticketDialogData$ = this.ticketDialogSource.asObservable();
    constructor() { }

    public forwardDataToNotification(data: ICustomNotification) {
        this.notificationDialogSource.next(data);
    }

    public closeNotification(){
        this.closeNotificationSource.next();
    }

    public closeConfirmTicketDialog(){
        this.forwardDataToTicketDialog();
    }

    public forwardDataToTicketDialog(data?: ITicketDialogModel) {
        this.ticketDialogSource.next(data);
  }
}
